import React from 'react';
import { Text } from 'elmo-elements';
import { Box, Alert } from 'extended-oxygen-elements';

export const NewPayRatesAlert = () => {
  return (
    <Box sx={{ mb: 2 }}>
      <Alert
        severity="warning"
        sx={{
          backgroundColor: 'rgba(251, 191, 36, 0.1)',
          color: '#ea580c',
          borderRadius: '10px',
          padding: '12px 16px',
          '& .MuiAlert-icon': {
            color: '#ea580c',
          },
        }}
      >
        <Text size={'sm'} className="role-alert-text">
          New pay rates are available
        </Text>
      </Alert>
    </Box>
  );
};


